let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kTkfd")).then(() => parcelRequire('e68Yk'));